import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { getFeedbackLogs, getChatLogs } from '../../services/logsApiClient';

export default function ChatLogsTab() {
  const [feedbackStart, setFeedbackStart] = useState('');
  const [feedbackEnd, setFeedbackEnd] = useState('');
  const [feedbackCountry, setFeedbackCountry] = useState('All');

  const [chatStart, setChatStart] = useState('');
  const [chatEnd, setChatEnd] = useState('');
  const [chatCountry, setChatCountry] = useState('All');

  const handleDownloadFeedback = () => {
    if (!feedbackStart || !feedbackEnd) {
      alert('Please select both start and end dates for Feedback Logs');
      return;
    }
    const countryCode = feedbackCountry === 'All' ? null : feedbackCountry;
    getFeedbackLogs(feedbackStart, feedbackEnd, countryCode);
  };

  const handleDownloadChat = () => {
    if (!chatStart || !chatEnd) {
      alert('Please select both start and end dates for Chat Logs');
      return;
    }
    const countryCode = chatCountry === 'All' ? null : chatCountry;
    getChatLogs(chatStart, chatEnd, countryCode);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {/* Feedback Logs Row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6">Feedback Logs</Typography>
        <TextField
          label="Start Date"
          type="date"
          value={feedbackStart}
          onChange={(e) => setFeedbackStart(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={feedbackEnd}
          onChange={(e) => setFeedbackEnd(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <FormControl sx={{ minWidth: 120 }} variant="outlined">
          <InputLabel shrink>Country</InputLabel>
          <Select
            value={feedbackCountry}
            onChange={(e) => setFeedbackCountry(e.target.value)}
            label="Country"
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="US">US</MenuItem>
            <MenuItem value="CA">CA</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          onClick={handleDownloadFeedback}
        >
          Download
        </Button>
      </Box>

      {/* Chat Logs Row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6">Chat Logs</Typography>
        <TextField
          label="Start Date"
          type="date"
          value={chatStart}
          onChange={(e) => setChatStart(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={chatEnd}
          onChange={(e) => setChatEnd(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <FormControl sx={{ minWidth: 120 }} variant="outlined">
          <InputLabel shrink>Country</InputLabel>
          <Select
            value={feedbackCountry}
            onChange={(e) => setFeedbackCountry(e.target.value)}
            label="Country"
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="US">US</MenuItem>
            <MenuItem value="CA">CA</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDownloadChat}
        >
          Download
        </Button>
      </Box>
    </Box>
  );
}
